<div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="8px">
  <div *ngIf="loan?.customerFacingStatus === loanStatus.Open">
    <span class="title">${{loan?.loanInfo?.availableFunds | shortNumber}}</span>
    <span class="mat-headline-6 secondary-text"> Available</span>
  </div>
  <mat-progress-bar *ngIf="loan?.customerFacingStatus === loanStatus.Open" mode="determinate" color="primary" [value]="utilization">
  </mat-progress-bar>
  <ifp-account-status-icon-chip
    *ngIf="loan?.customerFacingStatus !== loanStatus.Open && !hasAvailableRenewalToSign && (drawEnabled || payEnabled || loan?.customerFacingStatus === loanStatus.PendingRenewal)"
    [status]="loan?.customerFacingStatus"
    [accountStatusIconChipModel]="accountStatusIconChipModel">
  </ifp-account-status-icon-chip>
  <div fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="8px">
    <button mat-button color="primary" (click)="onClickDraw()" [disabled]="!drawEnabled"
      *ngIf="!hasAvailableRenewalToSign && drawEnabled" [fxHide.lt-sm]="showAvailableFunds"
      [fxHide.lt-md]="widgetLayout" name="draw">
      <span>DRAW</span>
    </button>
    <button mat-button color="primary" (click)="onClickPayment()" *ngIf="payEnabled"
      [fxHide.lt-sm]="showAvailableFunds" [fxHide.lt-md]="widgetLayout">
      <span>PAY</span>
    </button>
  </div>
</div>
